{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$ref": "#/definitions/ITranslationApiResponse",
  "definitions": {
    "ITranslationApiResponse": {
      "type": "object",
      "properties": {
        "status": {
          "type": "string",
          "const": "ok"
        },
        "translations": {
          "type": "array",
          "items": {
            "type": "object",
            "properties": {
              "key": {
                "type": "string"
              },
              "value": {
                "type": ["string", "null"]
              }
            },
            "required": ["key", "value"],
            "additionalProperties": false
          }
        }
      },
      "required": ["status", "translations"],
      "additionalProperties": false
    }
  }
}
